// extracted by mini-css-extract-plugin
module.exports = {"divider":"itemFlow_document_divider__YiOsg","wrapper":"itemFlow_document_wrapper__iSsAu"};